import axios from "axios";
import { HOST } from "../../setting";

export const service = () => {
  return axios.get(`${HOST}/master/item-list`);
};
